import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import * as $ from 'jquery';
import { IAsset } from './asset.interface';
import { FileItem } from 'ng2-file-upload';

@Component({
    selector: 'clearance-image',
    template: require('./clearance-item-image.component.html')
})

export class ClearanceItemImageComponent extends ClearanceItemAssetBaseComponent implements IAsset {

    supportedImages: string[] = ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'jpeg','jpg','png', 'bmp'];

    setDefaultAssetImage() {
        //TDO
        throw new Error("Method not implemented.");
    }
   
    //--IsActualImage
    get IsActualImage(): boolean {

        var fileType = this.assetItemForm.get('fileType').value;
        if (!this.supportedImages.find(f => f == fileType)) {
            return false;
        }

        return true;
    }

    get ciImageStyle() {
        var styleObject = { 
            'background-image': 'url(' + this.assetItemForm.get('fullUrl').value + ')'
        }
        //highlight on new image
        if (this.assetItemForm.get('highlighted').value){
            styleObject['border-color'] = "lime";
            styleObject['border-style'] = "solid";
            styleObject['border-width'] = "medium";
        }
        return styleObject;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/clearance-item-image.component.ts